import { useCallback } from "react";

const useWsArchiveHandlers = ({
  handleListArchives,
  setProjectState,
  setResetProgressHistory,
  managedSetTimeout,
  setMessages,
  setFiles,
  setActiveFile,
  clearProjectStateAndHistory,
  setSelectedRoles,
  setMicroSceneBubbles,
  setLearningLog,
  setFileNameCounts,
  setSelectedDiffLines,
  setCurrentDiffMessageIndex,
  setDiffComments,
  setAdoptedExpertOpinions,
  setSelectedExpert,
  setIsInExpertMode,
  setCurrentExpertCommand,
  setIsMessageInputEnabled,
  setShouldFlash,
  setHasUserSentMessage,
  setFlowName,
  ws,
  sessionId,
  isRestoringArchiveRef,
  logAction,
  setIsLoading,
  setIsWaitingResponse,
  setIsRestoringArchive,
  setArchivesList,
  setProjectId,  // 新增：用于恢复存档时设置 projectId
}) => {
  return useCallback((data) => {
    if (data.type === "delete_archive_success") {
      alert("删除存档成功");
      handleListArchives();
      return true;
    }

    if (data.type === "recover_archive_success") {
      console.log("恢复存档成功，开始重置状态...");

      setProjectState("");
      setResetProgressHistory(true);
      managedSetTimeout(() => setResetProgressHistory(false), 100);

      setMessages([]);
      setFiles({});
      setActiveFile(null);
      clearProjectStateAndHistory();
      setSelectedRoles([]);
      setMicroSceneBubbles([]);
      setLearningLog([]);

      setFileNameCounts({});
      setSelectedDiffLines({});
      setCurrentDiffMessageIndex(null);
      setDiffComments({});

      setAdoptedExpertOpinions({});
      setSelectedExpert(null);
      setIsInExpertMode(false);
      setCurrentExpertCommand("");

      setIsMessageInputEnabled(false);
      setShouldFlash(false);
      setHasUserSentMessage(true);
      console.log("恢复存档成功，设置 hasUserSentMessage 为 true");

      if (data.FlowName) {
        console.log("从存档恢复FlowName:", data.FlowName);
        const simulateFlowTypeSelection = (flowType) => {
          console.log(`模拟设置流程类型为: ${flowType}`);
          setFlowName(flowType);
        };
        simulateFlowTypeSelection(data.FlowName);
      }

      // 🔧 恢复存档时设置 projectId，用于 ExpertService 专家会话隔离
      let restoredProjectId = data.ProjectID;
      if (data.ProjectID) {
        console.log("从存档恢复ProjectID:", data.ProjectID);
        setProjectId(data.ProjectID);
      } else {
        // 旧存档没有 projectId，生成新的（无法延续专家对话历史）
        restoredProjectId = "proj_" + Date.now() + "_" + Math.random().toString(36).substr(2, 9);
        console.log("旧存档无ProjectID，生成新的:", restoredProjectId);
        setProjectId(restoredProjectId);
      }

      if (ws.current && ws.current.readyState === WebSocket.OPEN) {
        console.log("正在请求恢复角色状态...");
        ws.current.send(
          JSON.stringify({
            type: "get_is_human",
            session_id: sessionId,
          })
        );

        // 🔧 通知后端更新 projectId（尤其是旧存档生成的新 projectId）
        ws.current.send(
          JSON.stringify({
            type: "update_project_id",
            project_id: restoredProjectId,
            session_id: sessionId,
          })
        );
        console.log("已发送 projectId 更新通知给后端:", restoredProjectId);
      }

      logAction("ARCHIVE_RESTORED_SUCCESSFULLY", { sessionId });
      setIsLoading(false);
      setIsWaitingResponse(false);
      return true;
    }

    if (data.type === "project_name_updated") {
      setArchivesList((prevList) =>
        prevList.map((archive) =>
          archive.archiveId === data.archive_id
            ? { ...archive, projectName: data.project_name }
            : archive
        )
      );
      return true;
    }

    if (data.type === "archives_summary") {
      try {
        const summaries = JSON.parse(data.summaries);
        setArchivesList(summaries);
      } catch (error) {
        console.error("解析存档摘要失败:", error);
      }
      return true;
    }

    return false;
  }, [
    clearProjectStateAndHistory,
    handleListArchives,
    isRestoringArchiveRef,
    logAction,
    managedSetTimeout,
    sessionId,
    setActiveFile,
    setAdoptedExpertOpinions,
    setArchivesList,
    setCurrentDiffMessageIndex,
    setCurrentExpertCommand,
    setDiffComments,
    setFileNameCounts,
    setFiles,
    setFlowName,
    setHasUserSentMessage,
    setIsInExpertMode,
    setIsLoading,
    setIsMessageInputEnabled,
    setIsRestoringArchive,
    setIsWaitingResponse,
    setLearningLog,
    setMessages,
    setMicroSceneBubbles,
    setProjectId,
    setProjectState,
    setResetProgressHistory,
    setSelectedDiffLines,
    setSelectedExpert,
    setSelectedRoles,
    setShouldFlash,
    ws,
  ]);
};

export default useWsArchiveHandlers;
